// extracted by mini-css-extract-plugin
export default {"container":"LayoutHeader_container__+YG33","header":"LayoutHeader_header__P5FST"};